const radioHeight = (width: number, height: number) => {
  let percent = width / 350;
  return Math.floor(height / percent);
};

const DEFAULT_WATERFALL_HEIGHT = Math.floor(350 * 0.6666);

const getSafeWaterfallHeight = (width?: number, height?: number) => {
  const realWidth = Number(width);
  const realHeight = Number(height);

  if (
    Number.isFinite(realWidth) &&
    realWidth > 0 &&
    Number.isFinite(realHeight) &&
    realHeight > 0
  ) {
    const result = radioHeight(realWidth, realHeight);
    if (Number.isFinite(result) && result > 0) {
      return result;
    }
  }

  return DEFAULT_WATERFALL_HEIGHT;
};

export interface IWaterItem {
  [key: string]: any;
  width?: number;
  height?: number;
}

export default function (original: any[], defaultWidth: number = 0, defaultHeight: number = 0) {

  let column1 = [] as IWaterItem[];
  let column2 = [] as IWaterItem[];

  let column1height = 0;
  let column2height = 0;

  original.forEach((it: IWaterItem, index: number) => {
    const one = {
      ...it,
      originalIndex: index
    };

    const oneWidth = !one.width && defaultWidth > 0 ? defaultWidth : Number(one.width);
    const oneHeight = !one.height && defaultHeight > 0 ? defaultHeight : Number(one.height);
    if (column1height <= column2height) {
      column1.push(one);
      column1height += getSafeWaterfallHeight(oneWidth, oneHeight);
    } else {
      column2.push(one);
      column2height += getSafeWaterfallHeight(oneWidth, oneHeight);
    }
  });

  return [column1, column2];
}
